import * as React from "react";
import type { SVGProps } from "react";
const SvgCountryGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      fillRule="evenodd"
      d="M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12m2.206-5.62a6.79 6.79 0 0 0 3.879-3.46h-2.748a12.3 12.3 0 0 1-.678 2.518q-.208.522-.453.941m-8.291-3.46a6.79 6.79 0 0 0 3.879 3.46 7 7 0 0 1-.454-.942 12.3 12.3 0 0 1-.677-2.518zm3.879-9.3a6.79 6.79 0 0 0-3.879 3.46h2.748c.155-.927.383-1.781.677-2.518q.21-.522.454-.941M12 5.25c-.492 0-1.07.68-1.507 1.773-.241.603-.433 1.3-.57 2.057h4.154a10.8 10.8 0 0 0-.57-2.057C13.07 5.929 12.492 5.25 12 5.25M5.25 12c0 .58.073 1.142.211 1.679h3.045a18.7 18.7 0 0 1 0-3.358H5.461A6.7 6.7 0 0 0 5.25 12m4.502 1.679h4.496a17.5 17.5 0 0 0 0-3.358H9.752a17.5 17.5 0 0 0 0 3.358M12 18.75c.492 0 1.07-.68 1.507-1.773.241-.603.433-1.3.57-2.057H9.923c.137.758.329 1.454.57 2.057.438 1.094 1.015 1.773 1.507 1.773M18.75 12c0-.58-.073-1.142-.211-1.679h-3.045a18.7 18.7 0 0 1 0 3.358h3.045c.137-.537.211-1.1.211-1.679m-.665-2.92a6.79 6.79 0 0 0-3.879-3.46q.245.42.454.942c.294.737.522 1.591.676 2.518zM19.991 12c0 4.406-3.585 7.991-7.991 7.991S4.009 16.406 4.009 12 7.594 4.009 12 4.009c4.407 0 7.991 3.585 7.991 7.991"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCountryGlobe;
